import { harborDuelsApiUrl, nonce } from '../utils/runtime';

function headers() {
  return {
    'Content-Type': 'application/json',
    ...(nonce ? { 'X-WP-Nonce': nonce } : {}),
  };
}

async function readJson(response) {
  const raw = await response.text();
  const payload = raw ? JSON.parse(raw) : null;
  if (!response.ok) {
    const message = payload?.message || payload?.data?.message || 'Der Hafenmeister konnte nicht erreicht werden.';
    const error = new Error(message);
    error.payload = payload;
    error.status = response.status;
    throw error;
  }
  return payload;
}

export async function loadHarborDuels() {
  const response = await fetch(harborDuelsApiUrl || '/wp-json/pfandpirat/v1/harbor/duels', {
    credentials: 'include',
    headers: nonce ? { 'X-WP-Nonce': nonce } : {},
  });
  return readJson(response);
}

export async function registerHarborDuel(eventSlug, prepSlugs = []) {
  const response = await fetch(`${harborDuelsApiUrl || '/wp-json/pfandpirat/v1/harbor/duels'}/register`, {
    method: 'POST',
    credentials: 'include',
    headers: headers(),
    body: JSON.stringify({ event_slug: eventSlug, prep_slugs: prepSlugs }),
  });
  return readJson(response);
}
